const advancedLang = (text: string = '', variables: string[]) => {
    let index = 0;

    return text.replace(/###/g, () => variables[index++])
}

export default advancedLang
